import { ThemeOptions, createTheme } from '@mui/material/styles';

export const themeOptions: ThemeOptions = createTheme({
  typography: {
    fontFamily: `'Lato', 'Inter', sans-serif`,
    h1: {
      fontSize: '6rem', // 96px
      fontWeight: 300,
      lineHeight: '7rem' // 112px
    },
    h2: {
      fontSize: '3.75rem', // 60px
      fontWeight: 300,
      lineHeight: '4.5rem' // 72px
    },
    h3: {
      fontSize: '3rem', // 48px
      fontWeight: 400,
      lineHeight: '3.5rem' // 56px
    },
    h4: {
      fontSize: '2.125rem', // 34px
      fontWeight: 400,
      lineHeight: '2.5rem' // 40px
    },
    h5: {
      fontSize: '1.5rem', // 24px
      fontWeight: 400,
      lineHeight: '2rem' // 32px
    },
    h6: {
      fontSize: '1.25rem', // 20px
      fontWeight: 500,
      lineHeight: '2rem' // 32px
    },
    subtitle1: {
      fontSize: '1rem', // 16px
      fontWeight: 400,
      lineHeight: '1.75rem' // 28px
    },
    subtitle2: {
      fontSize: '0.875rem', // 14px
      fontWeight: 500,
      lineHeight: '1.5rem' // 24px
    },
    body1: {
      fontSize: '1rem', // 16px
      fontWeight: 400,
      lineHeight: '1.75rem' // 28px
    },
    body2: {
      fontSize: '0.875rem', // 14px
      fontWeight: 400,
      lineHeight: '1.25rem' // 20px
    },
    button: {
      fontSize: '0.875rem', // 14px
      fontWeight: 500,
      lineHeight: '1rem', // 16px
      textTransform: 'uppercase'
    },
    caption: {
      fontSize: '0.75rem', // 12px
      fontWeight: 400,
      lineHeight: '1rem' // 16px
    },
    overline: {
      fontSize: '0.625rem', // 10px
      fontWeight: 400,
      lineHeight: '1rem', // 16px
      textTransform: 'uppercase'
    }
  },
  palette: {
    mode: 'light',
    primary: {
      main: '#234D8C',
      light: '#2C60AE',
      dark: '#1B3A6A',
      contrastText: '#FFFFFF'
    },
    secondary: {
      main: '#4D58FF',
      light: '#4D91FF',
      dark: '#6B6E99',
      contrastText: '#FFFFFF'
    },
    error: {
      main: '#D32F2F',
      dark: '#C62828',
      light: '#EF5350',
      contrastText: '#FFFFFF'
    },
    warning: {
      main: '#EF6C00',
      dark: '#E65100',
      light: '#FF9800',
      contrastText: '#FFFFFF'
    },
    info: {
      main: '#0288D1',
      dark: '#01579B',
      light: '#03A9F4',
      contrastText: '#FFFFFF'
    },
    success: {
      main: '#2E7D32',
      dark: '#1B5E20',
      light: '#4CAF50',
      contrastText: '#FFFFFF'
    },
    background: {
      default: '#FFFFFF',
      paper: '#FFFFFF'
    }
  },
  breakpoints: {
    values: {
      xs: 0, // Extra small devices (phones)
      sm: 600, // Small devices (tablets)
      md: 900, // Medium devices (small laptops)
      lg: 1200, // Large devices (desktops)
      xl: 1536 // Extra large devices (big screens)
    }
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          margin: 0,
          padding: 0,
          boxSizing: 'border-box'
        },
        html: {
          margin: 0,
          padding: 0,
          boxSizing: 'border-box'
        },
        '*, *::before, *::after': {
          boxSizing: 'inherit'
        }
      }
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'none' // Prevents uppercase transformation
        }
      }
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          '&.Mui-disabled .MuiFormLabel-asterisk': {
            color: 'rgba(0, 0, 0, 0.38)' // Match MUI's default disabled text color
          }
        },
        asterisk: {
          color: '#D32F2F'
        }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '&.Mui-disabled': {
            backgroundColor: '#F5F5F5',
            '& input': {
              WebkitTextFillColor: 'rgba(0, 0, 0, 0.87)' // Default text color for filled disabled inputs
            }
          }
        }
      }
    }
  }
});
